// Actions for VatPeriodExport

import {
  VAT_INVOICE_LIST,
  VAT_INVOICE_LIST_SUCCESS,
  VAT_INVOICE_LIST_FAIL,
  VAT_INVOICE_ITEM_LIST,
  VAT_INVOICE_ITEM_LIST_SUCCESS,
  VAT_INVOICE_ITEM_LIST_FAIL,
  VAT_PURCHASE_LIST,
  VAT_PURCHASE_LIST_SUCCESS,
  VAT_PURCHASE_LIST_FAIL,
  VAT_PURCHASE_ITEM_LIST,
  VAT_PURCHASE_ITEM_LIST_SUCCESS,
  VAT_PURCHASE_ITEM_LIST_FAIL,
} from "./actionType";

// VAT Invoice List
export const vatInvoiceList = (data) => ({ type: VAT_INVOICE_LIST, data });
export const vatInvoiceListSuccess = (data) => ({
  type: VAT_INVOICE_LIST_SUCCESS,
  data,
});
export const vatInvoiceListFail = (data) => ({
  type: VAT_INVOICE_LIST_FAIL,
  data,
});

// VAT Invoice Item List
export const vatInvoiceItemList = (data) => ({
  type: VAT_INVOICE_ITEM_LIST,
  data,
});
export const vatInvoiceItemListSuccess = (data) => ({
  type: VAT_INVOICE_ITEM_LIST_SUCCESS,
  data,
});
export const vatInvoiceItemListFail = (data) => ({
  type: VAT_INVOICE_ITEM_LIST_FAIL,
  data,
});

// VAT Purchase List
export const vatPurchaseList = (data) => ({ type: VAT_PURCHASE_LIST, data });
export const vatPurchaseListSuccess = (data) => ({
  type: VAT_PURCHASE_LIST_SUCCESS,
  data,
});
export const vatPurchaseListFail = (data) => ({
  type: VAT_PURCHASE_LIST_FAIL,
  data,
});

// VAT Purchase Item List
export const vatPurchaseItemList = (data) => ({
  type: VAT_PURCHASE_ITEM_LIST,
  data,
});
export const vatPurchaseItemListSuccess = (data) => ({
  type: VAT_PURCHASE_ITEM_LIST_SUCCESS,
  data,
});
export const vatPurchaseItemListFail = (data) => ({
  type: VAT_PURCHASE_ITEM_LIST_FAIL,
  data,
});
